import {
  CertificationBuilder,
  UpdateCertificationInput,
  UpdateCertificationOutput,
} from '../certifications.types';

export const updateCertification = (builder: CertificationBuilder) =>
  builder.mutation<UpdateCertificationOutput, UpdateCertificationInput>({
    query: ({ CandidateCertificationId, ...args }) => ({
      url: `candidate-certifications/${CandidateCertificationId}`,
      method: 'PUT',
      body: args,
    }),
    invalidatesTags: () => [{ type: 'Certification' }],
  });
